import { jsx as _jsx } from "react/jsx-runtime";
import RelationSearch from '../RelationSearch';
export var FilterRelationSearch = function (_a) {
    var item = _a.item, itemName = _a.itemName, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(RelationSearch, { onChange: function (value) {
                var _a;
                var _b, _c;
                setFilter((_a = {},
                    _a[item] = (_b = value === null || value === void 0 ? void 0 : value.id) !== null && _b !== void 0 ? _b : undefined,
                    _a[itemName] = (_c = value === null || value === void 0 ? void 0 : value.label) !== null && _c !== void 0 ? _c : undefined,
                    _a.invoiceStreamId = undefined,
                    _a));
            }, initialSelectedItem: activeFilters[item] && activeFilters[itemName]
                ? { key: activeFilters[item], label: activeFilters[itemName] }
                : undefined })),
    });
};
